import { Reviews } from './../../../../dto/product/product-option.entity';
import { Component, OnInit, Input, AfterViewInit, ElementRef } from '@angular/core';
import { Product } from '../../../../dto';
import { BaseComponent } from '../../../../core';
import { CodeService, CommonCode } from '../../../../shared';
import { GaService } from 'src/app/services';
// import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { Utils } from '../../../../common';
// import { Gallery } from '@ngx-gallery/core';
// import { Lightbox } from '@ngx-gallery/lightbox';
@Component({
  selector: 'app-product-reviews',
  templateUrl: './product-reviews.component.html',
  styleUrls: ['./product-reviews.component.scss'],
})
export class ProductReviewsComponent extends BaseComponent implements OnInit, AfterViewInit {
  @Input()
  product: Product;

  dataset = [];

  lang = this.LANGUAGES[0];
  reviewLanguages = this.REVIEW_LANGUAGES[0];
  businessTypeCode: CommonCode[];
  // recentMediaConfig: SwiperConfigInterface = {};

  oneStar: number;
  twoStar: number;
  threeStar: number;
  fourStar: number;
  fiveStar: number;

  reviews: Reviews[] = [];
  pageSize: number;
  totalPage: number;
  pageNumber: number;
  changeRating: number;

  constructor(
    private elRef: ElementRef // private lightbox: Lightbox,
  ) // private gallery: Gallery
  {
    super();
  }

  ngOnInit() {
    this.pageSize = 10;
    this.pageNumber = 1;
    this.changeRating = 0;
    this.totalPage = Number(this.product.mapperSaleProducts[0].productOption.productReviews.reviews.length / 10);

    this.initSwiper();
    this.getReviewRatingDistribution();
    this.getPageReviews();
  }

  ngAfterViewInit() {
    this.dataset = JSON.parse(JSON.stringify(this.elRef.nativeElement.dataset));
  }

  initSwiper() {
    // this.recentMediaConfig = this.makeSwiperConfig({
    //   threshold: 50,
    //   spaceBetween: 24,
    //   slidesPerView: 10,
    //   pagination: false,
    //   navigation: {
    //     nextEl: '.button-next-recent-media',
    //     prevEl: '.button-prev-recent-media',
    //   },
    // });
  }

  getReviewRatingDistribution() {
    if (this.reviews) {
      this.oneStar = this.product.mapperSaleProducts[0].productOption.reviewDetails.ratingDistribution.oneStar;
      this.twoStar = this.product.mapperSaleProducts[0].productOption.reviewDetails.ratingDistribution.twoStar;
      this.threeStar = this.product.mapperSaleProducts[0].productOption.reviewDetails.ratingDistribution.threeStar;
      this.fourStar = this.product.mapperSaleProducts[0].productOption.reviewDetails.ratingDistribution.fourStar;
      this.fiveStar = this.product.mapperSaleProducts[0].productOption.reviewDetails.ratingDistribution.fiveStar;

      const starArray = [this.oneStar, this.twoStar, this.threeStar, this.fourStar, this.fiveStar];
      const maxStarValue = starArray.reduce((op, item) => (op = op > item ? op : item), 0) * 1.3;

      this.oneStar = Utils.getPointToFixed(100 - (this.oneStar / maxStarValue) * 100);
      this.twoStar = Utils.getPointToFixed(100 - (this.twoStar / maxStarValue) * 100);
      this.threeStar = Utils.getPointToFixed(100 - (this.threeStar / maxStarValue) * 100);
      this.fourStar = Utils.getPointToFixed(100 - (this.fourStar / maxStarValue) * 100);
      this.fiveStar = Utils.getPointToFixed(100 - (this.fiveStar / maxStarValue) * 100);
    }
  }

  getPageReviews() {
    // const trimLeft = (this.pageNumber - 1) * this.pageSize;
    const trimLeft = 0;
    const trimRight = this.pageNumber * this.pageSize;
    this.reviews = this.product.mapperSaleProducts[0].productOption.productReviews.reviews.slice(trimLeft, trimRight);
  }

  onShowMoreReviews() {
    this.pageNumber = this.pageNumber + 1;
    this.getPageReviews();
  }

  imageOpen(index: number, images: any): void {
    // const lightboxRef = this.gallery.ref('lightbox');
    // lightboxRef.reset();
    // images.map((image) => {
    //   lightboxRef.addImage({ src: image });
    // });
    // this.lightbox.open(index);
  }

  videoOpen(index: number, videoUrls: any): void {
    console.log('index', index);
    // const lightboxRef = this.gallery.ref('lightbox');
    // lightboxRef.reset();
    // videoUrls.map((videoUrl) => {
    //   lightboxRef.addVideo({ src: videoUrl });
    // });
    // this.lightbox.open(index);
  }

  onMouseoverRating(rating: number) {
    this.changeRating = rating;
  }

  onMouseoutRating() {
    this.changeRating = 0;
  }
}
